<mat-form-field
  *ngIf="!rangeCalendar && !newCalendar"
  appearance="fill"
  class="datepicker w-100 radius-base {{ classDiv }}">
  <input
    #input
    matInput
    name="picker"
    readonly
    [max]="max"
    [min]="min"
    [matDatepicker]="picker3"
    [ngModel]="modelControl"
    placeholder="{{ placeholder | translate }}"
    [id]="idCalendar || 'idCalendar'"
    [matDatepickerFilter]="filterDate"
    (click)="picker3.open()"
    (dateChange)="clickAction($event)" />

  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
  <mat-datepicker
    #picker3
    (closed)="removeCalendarOverlayMenuChild()"
    (opened)="markCalendarOverlayAsMenuChild()">
  </mat-datepicker>
</mat-form-field>

<mat-form-field
  *ngIf="!!rangeCalendar"
  appearance="fill"
  hideRequiredMarker="true"
  class="calendar-range w-100">
  <mat-label>{{ placeholder | translate }}</mat-label>
  <mat-date-range-input
    [formGroup]="range"
    [rangePicker]="pickerRange"
    (click)="pickerRange.open()">
    <input
      matStartDate
      readonly
      formControlName="start"
      (dateChange)="clickFirstDate()" />
    <input matEndDate readonly formControlName="end" />
  </mat-date-range-input>
  <mat-datepicker-toggle matSuffix [for]="pickerRange"></mat-datepicker-toggle>
  <mat-date-range-picker
    #pickerRange
    (closed)="removeCalendarOverlayMenuChild()"
    (opened)="markCalendarOverlayAsMenuChild()"
  >
    <mat-date-range-picker-actions>
      <button
        mat-button
        matDateRangePickerCancel
        class="h-36px px-16"
        (click)="clickRangeClear()">
        {{ 'actions.clean' | translate }}
      </button>
      <button
        mat-raised-button
        matDateRangePickerApply
        class="background-purple h-36px ml-8 px-16 radius-5 white"
        color="primary"
        (click)="clickRange()">
        {{ 'actions.apply' | translate }}
      </button>
    </mat-date-range-picker-actions>
  </mat-date-range-picker>
</mat-form-field>

<mat-form-field
  *ngIf="!!newCalendar"
  appearance="fill"
  hideRequiredMarker="true"
  class="calendar-range w-100 {{ classDiv }}">
  <mat-label>{{ placeholder | translate }}</mat-label>
  <input
    matInput
    name="picker"
    readonly
    [max]="max"
    [min]="min"
    [matDatepicker]="dp3"
    [formControl]="picker"
    [matDatepickerFilter]="filterDate"
    (click)="dp3.open()"
    (dateChange)="clickCalendar()" />
  <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
  <mat-datepicker
    #dp3
    disabled="false"
    (closed)="removeCalendarOverlayMenuChild()"
    (opened)="markCalendarOverlayAsMenuChild()">
  </mat-datepicker>
</mat-form-field>
